import React from 'react';
import { useAppContext } from '../../../contexts/AppContext';
import SubscriptionBanner from './SubscriptionBanner';
import SubscriptionAlertModal from './SubscriptionAlertModal';
import { useSubscriptionAlert } from '../hooks/useSubscriptionAlert';

// =============================================================================
// COMPONENTE
// =============================================================================

const SubscriptionAlerts: React.FC = () => {
    const { setCurrentPage } = useAppContext();
    const {
        alert,
        shouldShowModal,
        dismissModal,
        getProgressPercentage
    } = useSubscriptionAlert();

    const handleAction = () => {
        if (alert?.ctaLabel) {
            setCurrentPage(alert.ctaPath);
            dismissModal();
        }
    };

    return (
        <>
            {/* Banner - sempre visível quando há alerta (exceto blocked) */}
            <SubscriptionBanner />

            {/* Modal - apenas para situações críticas */}
            {shouldShowModal && alert && (
                <SubscriptionAlertModal
                    alert={alert}
                    progressPercentage={getProgressPercentage()}
                    onAction={handleAction}
                    onDismiss={alert.severity !== 'blocked' || !alert.ctaLabel ? dismissModal : undefined}
                />
            )}
        </>
    );
};

export default SubscriptionAlerts;
